/*
 * Module for handling of ajax navigation links
 */
rs.module("content/vendor/paymentmethod/edit",

    [ "common/visibility", "ui/framework/client-templates" ],

    function (visibility, clientTemplates) {

        // initialize the module
        function initialize(jsSelectors, templateKeys, codeValues, backendUrl, vendorPartyKey) {
            var paymentMethodDiv = $.js(jsSelectors.paymentMethodDiv);

            var paymentMethodSelect = paymentMethodDiv.js(jsSelectors.paymentMethodSelect);
            var addressSelect = paymentMethodDiv.js(jsSelectors.addressSelect);
            var addressContent = paymentMethodDiv.js(jsSelectors.addressContent);
            var achSection = paymentMethodDiv.js(jsSelectors.achSection);

            paymentMethodSelect.change(paymentMethodChanged);
            addressSelect.change(addressTypeChanged);

            paymentMethodChanged();

            // update UI after payment method change
            function paymentMethodChanged() {
                visibility.setVisible(achSection, paymentMethodSelect.val() == codeValues.achCode);

                addressTypeChanged();
            }

            // update UI after address type change
            function addressTypeChanged() {
                $.getJSON(backendUrl, { ownerKey: vendorPartyKey, addressType: addressSelect.val() }).done(function (data) {
                    addressContent.html(clientTemplates.render(templateKeys.addressTemplate, data));
                });
            }
        }

        var exports = {
            initialize: initialize
        };

        return exports;
    }
);